import React, { useEffect, useState } from "react";
import style from "./Cylinders.module.scss";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../components/paginationCopy/Pagination";
import Search from "../../components/search";
import { loadSeries } from "../../redux/admin/actions/admin.actions";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import { MdOutlineKeyboardBackspace, MdQrCode2 } from "react-icons/md";
import GenerateCode from "./GenerateCode.component";
import { useNavigate } from "react-router-dom";
import { MyButton } from "../../Hooks/useButton";
import CylinderStats from "../../components/CylinderStats/CylinderStats";
import CircularLoader from "../../components/Loader/CircularLoader";
// import { delay } from "../../components/utils/timer";

const Series = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [updateType, setUpdateType] = useState(false);
  const [dataMatch, setDataMatch] = useState("");
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  const code = localStorage.getItem("batch");

  const navigate = useNavigate();

  const { series } = useSelector((state) => state.adminReducer);

  const loadSeriesFunc = () => {
    setLoading(true);
    // await delay(2000);
    dispatch(loadSeries(code));
    setLoading(false);
  };

  useEffect(() => {
    loadSeriesFunc();
  }, []);

  // Search handler
  useEffect(() => {
    setData(
      series?.filter((id) => {
        return Object.values(id).some((name) =>
          String(name).toLowerCase().includes(search.toLowerCase())
        );
      })
    );
  }, [series, search]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 10;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(data?.length / size);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const handleRow = (data) => {
    setUpdateType(true);

    let match = series?.find((t) => t?.code === data?.code);
    if (match) {
      setDataMatch(match.code);
    }
  };

  const headers = [
    { key: "index", label: "S/N" },
    { key: "size", label: "Cylinder SIze" },
    { key: "code", label: "Code" },
    { key: "address", label: "Last Known" },
    { key: "date_created", label: "Date" },
  ];

  const stats = [
    {
      name: "In Batch",
      value: "",
    },

    {
      name: "In Hospitals",
      value: "",
    },
    {
      name: "With Riders",
      value: "",
    },
    {
      name: "In Offices",
      value: "",
    },
    {
      name: "In Plants",
      value: "",
    },
  ];

  return (
    <>
      <div
        onClick={() => navigate(-1)}
        className='arrow'
        style={{ cursor: "pointer" }}
      >
        <MdOutlineKeyboardBackspace
          style={{
            color: "#fff",
            background: "#2784ef",
            borderRadius: "50%",
            padding: "4px",
          }}
          size={30}
        />{" "}
      </div>
      <div>
        <CylinderStats stats={stats} />
      </div>
      <div className='d-flex justify-content-between m-3'>
        <div> </div>
        <Search placeholder='Search' onChange={handleChange} />
      </div>
      <section style={{ maxWidth: "95%", margin: "auto" }}>
        {/* {} */}
        <Table borderless responsive className='mt-4'>
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return <td key={row.label}>{row.label} </td>;
              })}
            </tr>
          </thead>
          {data?.length > 0 ? (
            <tbody>
              {data
                ?.sort((a, b) => (a?.id > b?.id ? -1 : 1))
                ?.slice(pagesVisited, pagesVisited + size)
                ?.map((hosp, index) => (
                  <tr className={style.tableBodyRow} key={index}>
                    <td style={{ width: "7vw" }}>
                      {" "}
                      {pageNumber * size + index + 1}
                    </td>
                    <td style={{ width: "20vw" }}>{hosp?.size}</td>
                    <td style={{ width: "12vw" }}>{hosp?.code}</td>
                    <td style={{ width: "15vw" }}>{hosp?.address}</td>
                    <td style={{ width: "15vw" }}>{hosp?.date_created}</td>

                    <td className='d-flex gap-3 justify-content-center align-items-center'>
                      <MdQrCode2
                        className={style.action}
                        style={{
                          color: "#213f7d",
                          fontSize: "25px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleRow(hosp)}
                      />{" "}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <tfoot className='d-flex justify-content-center align-items-center'>
              <tr>
                <td>No record found</td>
              </tr>
            </tfoot>
          )}
        </Table>
        {data?.length > size && (
          <Pagination pageCount={pageCount} onPageChange={changePage} />
        )}
      </section>

      <div className='batch'>
        <MyButton
          text='Batch Download'
          onClick={() => navigate("/codes")}
          btnClass='w-100 mt-2'
        />
      </div>

      {/* update Modal */}
      <ConfirmationModal
        open={updateType}
        handleClose={() => setUpdateType(false)}
        closemodal={() => setUpdateType(false)}
        bgcolor=' rgba(255, 255, 255, 0.92)'
        width='20vw'
        instruction={<GenerateCode code={dataMatch} />}
      />
    </>
  );
};

export default Series;
